// ProGatePanel — Shown inside the publish modal when a FREE user attempts
// PRO-only features (video upload, >500 chars, polls, premium, co-author).
import React from "react";
import { Crown } from "lucide-react";

const REASONS = {
  video: "Los vídeos son una funcionalidad PRO. Hazte PRO para publicar vídeos de hasta 90 segundos.",
  chars: (n) => `Las cuentas FREE pueden publicar hasta ${n} caracteres. Hazte PRO para sin límite (hasta 5000).`,
};

export const ProGatePanel = ({
  reason,
  proBusy,
  proErr,
  onUpgrade,
  onBack,
  ui,
  freeMaxChars,
}) => (
  <div className="p-7 text-center">
    <div className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full border border-amber-400/40 bg-amber-400/10">
      <Crown className="h-6 w-6 text-amber-300" />
    </div>
    <h3 className="mt-4 text-2xl font-black tracking-tight">{ui.pam_pro_gate_title}</h3>
    <p className="mt-2 text-sm text-white/55">
      {reason === "video"
        ? REASONS.video
        : reason === "chars"
        ? REASONS.chars(freeMaxChars)
        : ui.pam_pro_gate_body}
    </p>
    <button
      onClick={onUpgrade}
      disabled={proBusy}
      className="mt-6 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-orange-500 to-amber-600 px-6 py-3 text-xs font-black uppercase tracking-[0.14em] text-black shadow-[0_8px_24px_rgba(255,140,0,0.45)] disabled:cursor-wait disabled:opacity-60"
      data-testid="shadow-publish-pro-cta"
    >
      <Crown className="h-4 w-4" />
      {proBusy ? (ui.pam_pro_gate_loading || "REDIRIGIENDO…") : ui.pam_pro_gate_cta}
    </button>
    {proErr && (
      <p className="mt-3 text-[11px] text-red-400" data-testid="shadow-publish-pro-error">
        {ui.pam_pro_gate_error || "No se pudo iniciar el pago. Reinténtalo."}
      </p>
    )}
    <button
      type="button"
      onClick={onBack}
      className="mt-4 text-[11px] text-white/40 underline-offset-2 transition-colors hover:text-white/70 hover:underline"
      data-testid="shadow-publish-progate-back"
    >
      ← Volver al editor
    </button>
  </div>
);

export default ProGatePanel;
